import { ConsultationTreatmentTypes } from '@enums/consultation-treatment-types';
import { UpsellSlugs } from '@enums/upsell-slugs';
import { TreatmentType } from '@models/treatment-types/treatment-type.model';

/**
 * Defines the STD Prevention (DoxyPEP) treatment type for STD and HL site.
 */
export const StdPreventionTreatment = new TreatmentType({
  id: '6',
  name: ConsultationTreatmentTypes.StdPrevention,
  eligibleTreatmentTypes: [
    {
      id: 3423,
      name: UpsellSlugs.Doxycycline15TreatmentsStd,
    },
    {
      id: 3424,
      name: UpsellSlugs.Doxycycline30TreatmentsStd,
    },
  ],
});
